export default __webpack_public_path__ + "static/media/timer_background_m2.33aae58c.jpg";